(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('MediaListController', MediaListController);

    /** @ngInject */
    function MediaListController($scope, $state, $stateParams, $rootScope, MediaService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        let newsPerPage;
        let newsSkip;
        let forcePaginationReset;
        let isTableSearch;

        vm.getNewsImage = news => {
            return HelperService.imageResizePath('news', news.Id, news.Image, 100, 100);
        }

        vm.isSearchDisabled = () => {
            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.getPaginatedMedias({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
            vm.searchText = '';
            vm.selectedCategory = null;

            if (isTableSearch) {
                vm.getPaginatedMedias({
                    page: vm.currentPage
                });

                isTableSearch = false;
            }
        }

        vm.getPaginatedMedias = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset) {
                vm.currentPage = 1;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            newsSkip = (vm.currentPage - 1) * newsPerPage;

            getMedias();
        }

        vm.onChangeCategory = () => {
            if (vm.selectedCategory) {
                let currentCategory = vm.categories.find(x => (x.Url == $stateParams.mediaCategory));
                let currentPage = $stateParams.mediaPage;

                $state.go('app-master.default.media', {
                    mediaPage: currentPage,
                    mediaCategory: vm.selectedCategory.Url
                });

                if (currentCategory.Id != vm.selectedCategory.Id)
                    currentPage = 1;

                vm.getPaginatedMedias({
                    page: currentPage
                })
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getMedias() {
            HelperService.startLoading('.media-holder');

            vm.medias = [];
            vm.isLoading = true;

            const parameters = prepareParameters();
            let userData = AuthenticationService.getUserData();

            parameters.ResponsibilityId = userData.Responsibility.Id;

            MediaService
                .getAllByParameters(parameters, userData.Id)
                .then(success => {
                    vm.medias = success.News;
                    vm.numberOfPages = success.NumberOfPages;
                    vm.isLoading = false;

                    $state.go('app-master.default.media', {
                        mediaPage: vm.currentPage
                    });

                    HelperService.stopLoading('.media-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters() {
            let params = {
                PerPage: newsPerPage,
                Skip: newsSkip,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                Active: true
            }

            if (vm.selectedCategory) {
                params.CategoryId = vm.selectedCategory.Id;
                isTableSearch = true;
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
                isTableSearch = true;
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
                isTableSearch = true;
            }

            return params;
        }

        function getCategories() {
            HelperService.startLoading('.media-holder');

            MediaService
                .getCategories()
                .then(success => {
                    vm.categories = success;

                    let currentCategory = vm.categories.find(x => (x.Url == $stateParams.mediaCategory));

                    if (currentCategory)
                        vm.selectedCategory = currentCategory;

                    vm.getPaginatedMedias({
                        page: vm.currentPage
                    });

                    HelperService.stopLoading('.media-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            newsPerPage = 5;
            newsSkip = 0;
            forcePaginationReset = false;
            isTableSearch = false;

            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.mediaPage)) {
                $state.go('app-master.default.media', {
                    mediaPage: 1
                });
            } else
                vm.currentPage = $stateParams.mediaPage;

            vm.medias = [];
            vm.isLoading = false;

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Amanhã': [
                            moment().add(1, 'days'),
                            moment().add(1, 'days')
                        ],
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ]
                    },
                    'eventHandlers': {
                        'cancel.daterangepicker': (ev, picker) => {
                            vm.datePicker.date = {
                                startDate: null,
                                endDate: null
                            };
                        }
                    }
                }
            }
        }

        function init() {
            initVars();

            getCategories();
        }
    }
}());